// extracted by mini-css-extract-plugin
export default {"wrapper":"PreloaderPortal_wrapper__ozl1Y"};